import React from 'react';
import { Button, Card } from './Ui';
import './Styles/ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundaryCaughtAnError:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="Crash-Page">
          <Card className="Crash-Card">
            <h1 className="Crash-Title">Oops! Something went wrong</h1>
            <p className="Crash-Text">
              We're sorry for the inconvenience. The application encountered an unexpected error.
            </p>
            {import.meta.env.DEV && (
              <details className="Crash-Details">
                <summary>Error details</summary>
                <pre className="Crash-Pre">
                  {this.state.error && this.state.error.toString()}
                </pre>
                {this.state.errorInfo && (
                  <pre className="Crash-Pre Crash-Pre--stack">
                    {this.state.errorInfo.componentStack}
                  </pre>
                )}
              </details>
            )}
            <Button variant="primary" onClick={() => window.location.reload()}>
              Reload application
            </Button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
